import { createAsyncThunk } from "@reduxjs/toolkit";
import { toastr } from "react-redux-toastr";
import { api } from "../../services/api/api.service";
import { API_AUTH_LOGIN, API_AUTH_ME, API_AUTH_PASSWORD, API_AUTH_REGISTRATION, API_AUTH_CODE } from "../../services/api/api.urls";
import { ILoginResponse, IAuthMeResponse, ILoginData, ISetPassword, ISetPasswordResponse, IRegistrationResponse, IRegistrationRequest } from "./Auth.interfaces";
import { TryCatch } from "../../services/TryCatch";
import { COMPANY_ABBR } from "../../common/constants/company";

export const postLogin = createAsyncThunk<ILoginResponse, ILoginData, { rejectValue: string }>(
    API_AUTH_LOGIN,
    async (loginPayload, { rejectWithValue }) => {
        let payload = {
            email: loginPayload.email,
            password: loginPayload.password
        } as ILoginData
        if (loginPayload.code) {
            payload = { ...payload, code: loginPayload.code }
        }
        const result = await TryCatch(
            () => api.post(API_AUTH_LOGIN, payload).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, 'Login error');
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)

export const setChangePassword = createAsyncThunk<ISetPasswordResponse, ISetPassword, { rejectValue: string }>(
    API_AUTH_PASSWORD,
    async (loginPayload, { rejectWithValue }) => {
        let payload = {
            email: loginPayload.email,
            password: loginPayload.password,
            codeFromEmail: loginPayload.codeFromEmail
        } as ISetPassword
        const result = await TryCatch(
            () => api.post(API_AUTH_PASSWORD, payload).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, `${result.error}`)
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)

export const authMe = createAsyncThunk<IAuthMeResponse, void, { rejectValue: string }>(
    API_AUTH_ME,
    async (_, { rejectWithValue }) => {
        const result = await TryCatch(
            () => api.get(API_AUTH_ME).then(res => res.data)
        );
        if (!result.success) {
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)

export const postRegistration = createAsyncThunk<IRegistrationResponse, IRegistrationRequest, { rejectValue: string }>(
    API_AUTH_REGISTRATION,
    async (payload, { rejectWithValue }) => {
        const result = await TryCatch(
            () => api.post(API_AUTH_REGISTRATION, payload).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, "User not registered");
            return rejectWithValue(result.error);
        }
        toastr.success(COMPANY_ABBR, "User registered");
        return result.data;
    }
);

export const sendConfirmCode = createAsyncThunk<IRegistrationResponse, string, { rejectValue: string }>(
    API_AUTH_CODE,
    async (payload, { rejectWithValue }) => {
        const result = await TryCatch(
            () => api.post(API_AUTH_CODE, payload).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, "Code does not send.");
            return rejectWithValue(result.error);
        }
        toastr.success(COMPANY_ABBR, "Code was sent.");
        return result.data;
    }
);
